import { omit } from "lodash";

import client from "../client";
import { postCreatePasswordConfig } from "./postCreatePasswordConfig";
import { PostCreatePasswordPayload } from "./types";

const postCreatePassword = async (data?: PostCreatePasswordPayload) =>
  await client({ ...postCreatePasswordConfig, data: omit(data, "authorization") });

export default { postCreatePassword };
